<template>
  <div class="sign-daily block-base" mg-stat-show="flag=610" mg-stat-lob="smod=sign">
    <div class="sign-info">
      <div class="title">
        <span class="main">签到拆盲盒 最高得10元现金</span>
      </div>
      <MSwitch :value="isRemind" label="提醒" @change="handleRemindChange" />
    </div>
    <div class="sign-tip">每天坚持签到 中大奖概率更高哦</div>
    <div class="sign-icons">
      <div class="scroll-container">
        <div class="icon-item" 
          v-for="(item, index) in signItems" 
          :key="index" 
          :class="{
            'current-day': item.isCurrentDayUnsigned && !item.status, 
            'unsigned': !item.status
          }"
          @click="handleSignClick(item)">
          <div class="icon-item-inner">
            <div class="icon-wrap">
              <!-- 已签到显示签到图标，未签到显示对应礼物类型图标 -->
              <div class="icon" :class="item.status ? 'sign' : item.type"></div>
            </div>
            <span class="txt">{{ getSignText(item) }}</span>
          </div>
        </div>
        <!-- 占位 -->
        <div class="pot"></div>
      </div>
    </div>
    <CongratulationDialog 
      v-model="showCongratulation" 
      title="成功获得"
      confirmText="立即收下"
      @close="onCongratulationClose"
      @confirm="onDialogConfirm"
    >
      <div class="content">
        <div class="amount" v-if="giftType === 13">{{ currentGiftName }}<span>元</span></div>
        <div class="amount" v-if="giftType === 1">{{ currentGiftName }}<span>积分</span></div>
      </div>
    </CongratulationDialog>

    <!-- 低版本提醒 -->
    <versionDialog ref="versionDialog" />
  </div>
</template>

<script>
import MSwitch from '@/v2-components/switch/index.vue'
import CongratulationDialog from '@/v2-components/dialog/congratulation.vue'
import { checkIn, taskSubscribe } from '@/request/cash'
import versionDialog from '@/v2-components/d-version-tips'

export default {
  components: {
    MSwitch,
    CongratulationDialog,
    versionDialog,
  },
  props: {
    signSettings: {
      type: Array,
      default: () => []
    },
    taskSign: {
      type: String,
    },
    subscribeStatus: {
      type: Number,
    },
    userTaskStageSign: {
      type: Number,
    },
    userTaskStatus: {
      type: Number,
    },
  },
  data() {
    return {
      isRemind: false,
      signItems: [],
      showCongratulation: false,
      currentGiftName: '',
      giftType: 13,
    }
  },
  watch: {
    subscribeStatus: {
      handler(val) {
        this.isRemind = val === 1; // 1是已订阅
      },
    },
    signSettings: {
      handler(newSettings) {
        if (newSettings && newSettings.length > 0) {
          // 转换数据结构
          const arr = newSettings.map(setting => ({
            type: this.getTypeFromGiftType(setting.giftType), // 礼物类型
            status: setting.userSettingStatus === 2 ? 1 : 0,  // 签到状态：2-已签到，1-未签到
            day: setting.checkinTimes,
            giftName: setting.giftType === 13 ? this.formatMoney(setting.giftQty) : setting.giftName // 保存礼物名称
          }));

          // userTaskStatus 表示用户签到的任务状态，1，今天未签到，2，今天已签到
          // userTaskStageSign 表示连续签到第几天
          for (let item of arr) {
            if (this.userTaskStatus !== 2) { // 可以签到
              if (item.day === (this.userTaskStageSign + 1)) {
                item.isCurrentDayUnsigned = true;
                item.canBeSign = true;
              } else {
                item.canBeSign = false;
              }
            } else { // 不可以签到
              item.canBeSign = false;
            }
          }

          this.signItems = arr;
        }
      },
      immediate: true
    }
  },
  methods: {
    // 分转元
    formatMoney(num = 0) {
      return (num / 100).toFixed(2);
    },
    getTypeFromGiftType(giftType) {
      // 只在未签到时显示的礼物类型
      switch (giftType) {
        case 1:
          return 'redpack'
        case 13:
          return 'gift'
        default:
          return 'gift' // 默认显示礼物图标
      }
    },
    async handleRemindChange(val) {
      this.reportClick({
        mod: 'remind_onoff',
        cont: '点击提醒开关按钮',
      });

      const wrappedHandler = this.$wrapClick(async () => {
        try {
          const changeTo = this.isRemind ? 2 : 1;

          const { code, data, msg } = await taskSubscribe({
            taskSign: this.taskSign,
            subscribe: changeTo,
          });

          if (code === 200) {
            this.isRemind = !this.isRemind;
          } else {
            this.$toast(msg);
          }
        } catch (error) {
          console.error('订阅状态修改失败:', error);
        }
      });
      wrappedHandler();
    },
    async handleSignClick(item) {
      this.reportClick(
        {
          mod: 'sign',
          cont: '点击签到按钮',
        }
      );

      // 检查版本，如果返回 false 表示版本过低，不继续执行
      if (!this.$refs.versionDialog.checkVersion()) {
        return;
      }

      const wrappedHandler = this.$wrapClick(async () => {
        if (item.status === 1) return; // 已签到点击无效
        if (!item.isCurrentDayUnsigned) return; // 只有当天未签到的可以继续

        try {
          const { data, code, msg } = await checkIn({
            taskSign: this.taskSign
          });

          if (code === 200) {
            this.reportClick(
              {
                mod: 'sign_succ',
                cont: '点击签到成功',
              }
            );

            this.giftType = data.obtainGifts[0]?.giftType;

            switch (data.obtainGifts[0]?.giftType) {
              case 13: // 现金
                this.currentGiftName = this.formatMoney(data.obtainGifts[0].giftQty, 2);
                break;
              case 1:  // 积分
                this.currentGiftName = data.obtainGifts[0].giftQty;
                break;
              default: // 其他
                this.currentGiftName = data.obtainGifts[0].giftName;
                break;
            }
    
            this.showCongratulation = true;

            // 处理签到点击
            if (!item.status) {
              item.status = 1; // 标记为已签到
            }
          } else {
            this.$toast(msg);
          }
        } catch (error) {
          console.error('签到失败:', error);
        }
      });
      wrappedHandler();
    },
    reportClick({ mod, cont }) {
      try {
        MgStat.send(
          'click',
          {},
          {
            cntp: 'score_newHome',
            mod,
            cont,
          }
        )
      } catch (error) {
        console.error('score_newHome 点击事件 上报失败' + mod + cont);
      }
    },
    refreshInfo() {
      this.$store.dispatch('queryCashUserInfo');
    },
    async onDialogConfirm() {
      this.refreshInfo();
      this.showCongratulation = false;
    },
    onCongratulationClose() {
      this.refreshInfo();
      this.showCongratulation = false;
    },
    getSignText(item) {
      return `第${item.day}天`;
    }
  }
}
</script>

<style scoped lang="less">
  @import './index.less';
</style>